import { z, ZodType, ZodTypeDef } from 'zod'

export const idOnlySchema = <T extends { id: number }>(
  idValidator: ZodType<number, ZodTypeDef, number>,
  options?: { message?: string }
): ZodType<T> => {
  return z.custom<T>(
    (val): val is T => {
      if (typeof val !== 'object' || val === null) return false
      const id = (val as T).id
      return idValidator.safeParse(id).success
    },
    { message: options?.message ?? 'Invalid or missing id' }
  )
}
